/* Nazakat Telecom — live catalogue loader.
   Reads the store's own public product feed, so new/removed products,
   categories, brands and filter counts update themselves. */
(function () {
  var STORE = 'https://nazakattelecom.shop';

  var GROUPS = [
    { key: 'all',      label: 'All products',       d: 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z' },
    { key: 'mobiles',  label: 'Mobile Phones',      d: 'M7 2h10v20H7zM10.5 19.5h3' },
    { key: 'second',   label: 'Second-Hand Phones', d: 'M6 3h12v18H6zM9.5 20.5h5M2 8l2-2 2 2' },
    { key: 'power',    label: 'Power Banks',        d: 'M2 7h16v10H2zM22 11v2M11 9l-2.5 3.5H11l-.5 3' },
    { key: 'chargers', label: 'Chargers & Adapters',d: 'M13 2 4 14h7l-1 8 9-12h-7z' },
    { key: 'cables',   label: 'Cables',             d: 'M7 2v4M11 2v4M5 6h8v5a4 4 0 0 1-4 4v3a4 4 0 0 0 4 4h6' },
    { key: 'buds',     label: 'Earbuds & Earphones',d: 'M3 14v-2a9 9 0 0 1 18 0v2M2 16a2 2 0 0 1 2-2h1v7H4a2 2 0 0 1-2-2zM22 16a2 2 0 0 0-2-2h-1v7h1a2 2 0 0 0 2-2z' },
    { key: 'speakers', label: 'Speakers',           d: 'M5 2h14v20H5zM12 5.5v.01M9 14a3 3 0 1 0 6 0 3 3 0 1 0-6 0' },
    { key: 'car',      label: 'Car Chargers',       d: 'M5 17h14M6 17l-1-6 2-4h10l2 4-1 6M8 17.5v.01M16 17.5v.01' },
    { key: 'mouse',    label: 'Keyboard & Mouse',   d: 'M8 3h8a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4zM12 7v3' },
    { key: 'unique',   label: 'Unique Products',    d: 'M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8zM18 16.5l.8 1.7 1.7.8-1.7.8-.8 1.7-.8-1.7-1.7-.8 1.7-.8z' }
  ];

  var TYPE_MAP = {
    'cable': 'cables', 'aux cable': 'cables', '3 in 1 cable': 'cables',
    'adapter': 'chargers', 'charger': 'chargers', 'wireless charger': 'chargers', 'charger and adaptor': 'chargers',
    'smartphone': 'mobiles', 'mobile': 'mobiles', 'mobile phone': 'mobiles',
    'second hand mobile phone': 'second', 'second hand': 'second',
    'speaker': 'speakers', 'soundbar': 'speakers', 'home theater': 'speakers',
    'powerbank': 'power', 'power bank': 'power',
    'wireless earphones': 'buds', 'earbuds': 'buds', 'wired earphones': 'buds', 'earphones': 'buds', 'neckband': 'buds',
    'car charger': 'car',
    'keyboard and mouse': 'mouse', 'mouse': 'mouse', 'keyboard': 'mouse'
  };

  function groupOf(type, tags) {
    var t = String(type || '').trim().toLowerCase();
    if (TYPE_MAP[t]) return TYPE_MAP[t];
    var joined = (t + ' ' + (tags || []).join(' ')).toLowerCase();
    var keys = Object.keys(TYPE_MAP);
    for (var i = 0; i < keys.length; i++) { if (joined.indexOf(keys[i]) !== -1) return TYPE_MAP[keys[i]]; }
    return 'unique';
  }

  function inr(n) { return '₹' + Math.round(n).toLocaleString('en-IN'); }

  function normalise(p) {
    var v = (p.variants || [])[0] || {};
    var price = parseFloat(v.price || 0);
    var cmp = parseFloat(v.compare_at_price || 0);
    var off = cmp > price ? Math.round((1 - price / cmp) * 100) : 0;
    var img = (p.images || [])[0];
    return {
      id: p.id,
      title: p.title,
      href: STORE + '/products/' + p.handle,
      img: img ? img.src : '',
      price: inr(price),
      n: price,
      was: cmp > price ? inr(cmp) : '',
      off: off ? '-' + off + '%' : '',
      d: off,
      cat: groupOf(p.product_type, p.tags),
      brand: p.vendor || 'Other',
      stock: (p.variants || []).some(function (x) { return x.available; })
    };
  }

  async function load() {
    var all = [];
    var feed = (typeof window !== 'undefined' && window.NZ_FEED) ? window.NZ_FEED : (STORE + '/products.json');
    var sep = feed.indexOf('?') === -1 ? '?' : '&';
    for (var page = 1; page <= 4; page++) {
      var res = await fetch(feed + sep + 'limit=250&page=' + page, { cache: 'no-cache' });
      if (!res.ok) throw new Error('feed ' + res.status);
      var json = await res.json();
      var batch = json.products || [];
      all = all.concat(batch);
      if (batch.length < 250) break;
    }
    return all.filter(function (p) { return (p.variants || []).length; }).map(normalise);
  }

  /* Weekly deal pick — every discounted product runs once per cycle before any
     repeat, never twice across a cycle boundary, identical for all visitors. */
  function weekIndex() { return Math.floor((Date.now() + 4 * 864e5) / (7 * 864e5)); }

  function baseOrder(cycle, pool) {
    var h = (Math.imul(cycle, 2654435761) ^ 0x9e3779b9) >>> 0;
    var order = pool.slice();
    for (var i = order.length - 1; i > 0; i--) {
      h = (Math.imul(h, 1103515245) + 12345) >>> 0;
      var j = h % (i + 1);
      var t = order[i]; order[i] = order[j]; order[j] = t;
    }
    return order;
  }

  function orderFor(cycle, pool) {
    var order = baseOrder(cycle, pool);
    var prev = baseOrder(cycle - 1, pool);
    if (order.length > 2 && order[0].id === prev[prev.length - 1].id) {
      var t = order[0]; order[0] = order[1]; order[1] = t;
    }
    return order;
  }

  function pickForWeek(products, w) {
    var pool = products.filter(function (p) { return p.d >= 15 && p.stock && p.img; })
      .sort(function (a, b) { return a.id - b.id; });
    if (!pool.length) return null;
    var L = pool.length;
    var cycle = Math.floor(w / L), slot = ((w % L) + L) % L;
    var p = orderFor(cycle, pool)[slot];
    var save = Number(String(p.was).replace(/[^0-9]/g, '')) - p.n;
    return Object.assign({}, p, { save: inr(save) });
  }

  function weekRange(w) {
    var start = new Date((w * 7 - 4) * 864e5);
    var end = new Date(start.getTime() + 6 * 864e5);
    var f = function (d) { return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }); };
    return f(start) + ' – ' + f(end);
  }

  function weekEnd() {
    var d = new Date(), day = d.getDay();
    d.setDate(d.getDate() + (day === 0 ? 7 : 7 - day));
    d.setHours(23, 59, 59, 0);
    return d.getTime();
  }

  window.NZCatalog = { STORE: STORE, GROUPS: GROUPS, load: load, groupOf: groupOf, inr: inr, weekIndex: weekIndex, pickForWeek: pickForWeek, weekRange: weekRange, weekEnd: weekEnd };
})();
